<template></template>
<script>
import proxy from "@pdfking/workflow/utils/proxy"

import { dismiss_dropdowns } from "../core/bootstrap"
import toggle_class from "../dom/toggle_class"
import navigate from "../routes/navigate"
import keyboard from "../state/keyboard"

export default {
  watch: {
    escape_pressed(v) {
      dismiss_dropdowns()
      this.close()
    },
  },
  methods: {
    close() {
      navigate()
    },
  },
  computed: proxy(keyboard, { ESCAPE: "escape_pressed" }),
  mounted() {
    this.toggled_class
      ? toggle_class(document.body, { [this.toggled_class]: true })
      : null
  },
  unmounted() {
    this.toggled_class
      ? toggle_class(document.body, { [this.toggled_class]: false })
      : null
  },
}
</script>
